module.exports = __webpack_public_path__ + "M3M2.png?ea9e38dfae6ec7fe89049c5d6f2b4940";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/M3M2.png
// module id = 105
// module chunks = 0